var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",class:[_vm.b(),_vm.className],style:(_vm.styleSizeName)},[_c('i',{staticClass:"iconfont icon-datetime"})])}
var staticRenderFns = []

export { render, staticRenderFns }